import React, { useEffect, useMemo, useState } from 'react';
import { ColorId } from 'referral-types';
import { GridSubthemeProps, useGridSubthemeColors } from './gridSubthemeShared';

const HoverFadeDotsGridBackground: React.FC<GridSubthemeProps> = (props) => {
  const [mouse, setMouse] = useState({ x: 0, y: 0 });
  const [isMouseOver, setIsMouseOver] = useState(false);

  const computedColors = useGridSubthemeColors(props.themeRevision, {
    colorId1: ColorId.Primary3,
    colorId2: ColorId.Primary5,
  });

  useEffect(() => {
    const handlePointerMove = (event: PointerEvent) => {
      const x = (event.clientX / window.innerWidth) * 100;
      const y = (event.clientY / window.innerHeight) * 100;
      setMouse({ x, y });
      setIsMouseOver(true);
    };

    const handlePointerLeave = () => {
      setIsMouseOver(false);
      setMouse({ x: 0, y: 0 });
    };

    const handleWindowBlur = () => {
      setIsMouseOver(false);
      setMouse({ x: 0, y: 0 });
    };

    const handleDocumentMouseOut = (event: MouseEvent) => {
      // When relatedTarget is null, the pointer left the browser viewport.
      if (!event.relatedTarget) {
        setIsMouseOver(false);
        setMouse({ x: 0, y: 0 });
      }
    };

    window.addEventListener('pointermove', handlePointerMove);
    window.addEventListener('pointerleave', handlePointerLeave);
    window.addEventListener('blur', handleWindowBlur);
    document.addEventListener('mouseout', handleDocumentMouseOut);

    return () => {
      window.removeEventListener('pointermove', handlePointerMove);
      window.removeEventListener('pointerleave', handlePointerLeave);
      window.removeEventListener('blur', handleWindowBlur);
      document.removeEventListener('mouseout', handleDocumentMouseOut);
    };
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        backgroundColor: computedColors.color1,
      }}
    >
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `radial-gradient(circle at center, ${computedColors.color2} 0 3px, transparent 3.2px 100%)`,
          backgroundSize: '36px 36px',
          opacity: isMouseOver ? 0.85 : 0.2,
          transition: 'opacity 120ms ease-out',
          WebkitMaskImage: isMouseOver
            ? `radial-gradient(circle 165px at ${mouse.x}% ${mouse.y}%, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.8) 60%, rgba(0, 0, 0, 0.3) 100%)`
            : 'none',
          maskImage: isMouseOver
            ? `radial-gradient(circle 165px at ${mouse.x}% ${mouse.y}%, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.8) 60%, rgba(0, 0, 0, 0.3) 100%)`
            : 'none',
        }}
      />
    </div>
  );
};

export default HoverFadeDotsGridBackground;
